import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Spacing16 } from 'autogen/design-tokens/tokens';
import { SeeAll } from 'autogen/translation-keys/trans-website-filter';
import ButtonWithActiveState from 'components/Button/ButtonWithActiveState';
import { breakpoint, sizes } from 'variables';
import useFilterMenu from '../../FilterMenu/shared/hooks/useFilterMenu';
import { rootMenuId } from './RootFilterMenu';

const StyledButtonWithActiveState = styled(ButtonWithActiveState)``;

const SeeAllFiltersRootMenuFilterOpener = React.forwardRef<HTMLButtonElement, any>((props, ref) => {
    const { openFilterMenu } = useFilterMenu(rootMenuId);
    const { t } = useTranslation();
    return (
        <StyledButtonWithActiveState ref={ref} size="lg" onClick={openFilterMenu} {...props}>
            <i>{t(SeeAll)}</i>
        </StyledButtonWithActiveState>
    );
});

export default SeeAllFiltersRootMenuFilterOpener;
